module.exports = "/work-site/img/person.a970815e.gif";